import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBoltLightning,
  faLocationDot,
  faSatelliteDish,
  faVideo,
  faWarehouse,
} from "@fortawesome/free-solid-svg-icons";

const Hero = () => {
  const windowHeight = window.innerHeight;
  const [activeIcon, setActiveIcon] = useState(null);
  const boxRef = useRef(null);

  const handleIconClick = (icon) => {
    setActiveIcon(icon);
  };

  useEffect(() => {
    const reveal = (className) => {
      var reveals = document.querySelectorAll(className);

      for (var i = 0; i < reveals.length; i++) {
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 150;

        if (elementTop < windowHeight - elementVisible) {
          reveals[i].classList.add("active");
        } else {
          reveals[i].classList.remove("active");
        }
      }
    };

    const handleClickOutside = (event) => {
      const isIconClick = event.target.closest(".tips-col");

      if (
        boxRef.current &&
        !boxRef.current.contains(event.target) &&
        !isIconClick
      ) {
        setActiveIcon(null);
      }
    };

    window.addEventListener("scroll", () => {
      reveal(".reveal");
      reveal(".reveal2");
      reveal(".reveal3");
      reveal(".reveal4");
    });

    document.addEventListener("mousedown", handleClickOutside);

    reveal(".reveal");
    reveal(".reveal2");
    reveal(".reveal3");
    reveal(".reveal4");

    return () => {
      window.removeEventListener("scroll", () => {
        reveal(".reveal");
        reveal(".reveal2");
        reveal(".reveal3");
        reveal(".reveal4");
      });

      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [windowHeight]);

  return (
    <>
      <Helmet>
        <title>Strona główna | Anten-Sat</title>
        <meta
          name="description"
          content="ANTEN-SAT | Montaż anten, ustawianie anten | Częstochowa i okolice"
        />
        <link rel="canonical" href="https://antensat.pl/" />
      </Helmet>

      <Container fluid className="hero">
        <Row className="p-4">
          <Col md={6} className="hero__left reveal2">
            <h1>
              Witamy w <span className="highlight">ANTEN-SAT</span>!
            </h1>
            <p>
              Jesteśmy firmą z wieloletnim doświadczeniem, specjalizującą się w
              montażu i serwisie systemów antenowych, telewizji przemysłowej
              oraz automatyki do bram. Działamy na rynku od 2001 roku, oferując
              kompleksowe usługi dla klientów indywidualnych i biznesowych na
              terenie Częstochowy i okolic.
            </p>
            <hr />
            <p>
              Nasza oferta obejmuje:
              <br />
              • Instalacje antenowe <br />
              • Monitoring i systemy zabezpieczeń <br />
              • Automatyka do bram <br />
              • Instalacje elektryczne i odgromowe <br />
              • Sprzedaż dekoderów DVB-T2 <br />
              • Serwis i naprawa urządzeń <br />
            </p>
          </Col>
          <Col md={6} className="hero__right reveal">
            <img src="/img/antena.png" className="img-fluid" alt="Logo" />
          </Col>
        </Row>

        <hr className="custom-hr" />

        <Row className="p-5">
          <Col md={5} className="hero__map reveal">
            <iframe
              title="Google Maps location of ANTEN-SAT"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d20203.874298236264!2d18.973582110839846!3d50.72950610000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4710b5c13e57b423%3A0x77ca538c9f65736f!2sANTEN-SAT%20anteny%20cz%C4%99stochowa%2C%20monta%C5%BC%2C%20ustawianie%20anten%2C!5e0!3m2!1spl!2spl!4v1740160375303!5m2!1spl!2spl"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </Col>
          <Col md={7} className="hero__opening-hours">
            <p className="reveal3">
              Prowadzimy sklep stacjonarny w Konopiskach przy ul. Stawowej 5,
              gdzie znajdziesz szeroki wybór anten, kamer, dekoderów oraz innych
              urządzeń RTV i elektronicznych.
            </p>
            <FontAwesomeIcon icon={faLocationDot} className="location-dot" />
            <span className="address">42-274, Konopiska, ul. Stawowa 5</span>
            <Container className="opening-hours mt-3 reveal2">
              <img
                src="/img/opening-hours.svg"
                className="img-fluid "
                alt="Opening-hours"
              />
            </Container>
          </Col>
        </Row>

        <hr className="custom-hr" />

        <Row className="pt-5 reveal4">
          <Col className="text-center" sm={12}>
            <h2>Sprawdź nasze porady</h2>
            <p className="small">Kliknij interesujący Cię kafelek</p>
          </Col>
        </Row>

        <Row className="pb-5 text-center tips-row d-flex justify-content-center gap-3 reveal2"
           >
          <Col
            sm={5}
            md={2}
            className={`tips-col ${
              activeIcon === "antenna" ? "icon-tips-active" : ""
            }`}
            onClick={() => handleIconClick("antenna")} 
          >
            <FontAwesomeIcon icon={faSatelliteDish} className="icon-tips" />
            <p className="tips">Jaką wybrać antenę?</p>
          </Col>

          <Col
            sm={5}
            md={2}
            className={`tips-col ${
              activeIcon === "lightning" ? "icon-tips-active" : ""
            }`}
            onClick={() => handleIconClick("lightning")}
          >
            <FontAwesomeIcon icon={faBoltLightning} className="icon-tips" />
            <p className="tips">
              Jak zapobiegać uszkodzeniom instalacji antenowych?
            </p>
          </Col>

          <Col
            sm={5}
            md={2}
            className={`tips-col ${
              activeIcon === "video" ? "icon-tips-active" : ""
            }`}
            onClick={() => handleIconClick("video")}
          >
            <FontAwesomeIcon icon={faVideo} className="icon-tips" />
            <p className="tips">Jak dobrać rodzaj monitoringu?</p>
          </Col>

          <Col
            sm={5}
            md={2}
            className={`tips-col ${
              activeIcon === "warehouse" ? "icon-tips-active" : ""
            }`}
            onClick={() => handleIconClick("warehouse")}
          >
            <FontAwesomeIcon icon={faWarehouse} className="icon-tips" />
            <p className="tips">Jak dbać o automatykę bramy?</p>
          </Col>
        </Row>

        <div ref={boxRef}>
          <Row
            className={`mx-5 p-4 hint1 mb-5 ${
              activeIcon === "antenna" ? "hint-active" : ""
            }`}
          >
            <Col md={7} className="hint1__left">
              <FontAwesomeIcon
                icon={faSatelliteDish}
                className="icon-tips"
              ></FontAwesomeIcon>
              <span className="tips2"> Jaką wybrać antenę?</span>
              <p className="tips-p">
                <br />
                <b>1. Sprawdź odległość do najbliższego nadajnika.</b> <br />•
                Możesz to zrobić korzystając ze strony:{" "}
                <Link to="https://emimaps.emitel.pl">emitel</Link> <br />
                <br />
                <b>2. Określ gdzie antena będzie zamontowana.</b> <br />• W
                przypadku montażu anteny na zewnątrz najlepiej by była
                umieszczona możliwie najwyżej (np. przymocowana do komina).{" "}
                <br />
                • W dużych miastach, pomiędzy blokami najlepszym wyborem będzie
                antena siatkowa, która ma szerszy kąt odbioru sygnału
                telewizyjnego, niż antena kierunkowa. <br />• W przypadku anteny
                wewnętrznej (w przestrzeni zamkniętej) musi być to antena
                aktywna ze wzmacniaczem. Zastosowanie takich anten ograniczone
                jest do miejsc o dużym natężeniu sygnału, w niewielkiej
                odległości od nadajnika.
              </p>
            </Col>
            <Col md={5} className="hint1__right">
              <img
                src="/img/hint1.jpg"
                className="img-fluid reveal2"
                alt="Opening-hours"
              />
            </Col>
            <Col md={4} className="hint1__bottom ">
              <img
                src="/img/map.png"
                className="img-fluid reveal"
                alt="Opening-hours"
              />
            </Col>
            <Col md={8} className="hint1__bottom">
              <table class="tg">
                <thead>
                  <tr>
                    <th class="tg-emnn" rowspan="2">
                      Rodzaj anteny
                    </th>
                    <th class="tg-emnn" colspan="4">
                      Odległość od nadajnika
                    </th>
                  </tr>
                  <tr>
                    <th class="tg-dduk">Do 10 km</th>
                    <th class="tg-dduk">10 - 30 km</th>
                    <th class="tg-dduk">30 - 50 km</th>
                    <th class="tg-dduk">&gt; 50 km</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="tg-dduk">Pokojowa</td>
                    <td class="tg-emnn">TAK</td>
                    <td class="tg-dduk">NIE</td>
                    <td class="tg-dduk">NIE</td>
                    <td class="tg-dduk">NIE</td>
                  </tr>
                  <tr>
                    <td class="tg-dduk">Siatkowa</td>
                    <td class="tg-emnn">TAK</td>
                    <td class="tg-emnn">TAK</td>
                    <td class="tg-dduk">NIE</td>
                    <td class="tg-dduk">NIE</td>
                  </tr>
                  <tr>
                    <td class="tg-dduk">Kierunkowa</td>
                    <td class="tg-emnn">TAK</td>
                    <td class="tg-emnn">TAK</td>
                    <td class="tg-emnn">TAK</td>
                    <td class="tg-dduk">NIE</td>
                  </tr>
                  <tr>
                    <td class="tg-dduk">Kierunkowa złożona</td>
                    <td class="tg-dduk">NIE</td>
                    <td class="tg-emnn">TAK</td>
                    <td class="tg-emnn">TAK</td>
                    <td class="tg-emnn">TAK</td>
                  </tr>
                </tbody>
              </table>
            </Col>
            <Col sm={12}>
              <p className="tips-p">
                W typowych warunkach można kierować się wskazówkami zawartymi w
                powyższej tabeli. Należy jednak pamiętać, że na jakość sygnału
                wpływają zarówno parametry nadawania z poszczególnych obiektów,
                jak i specyficzne uwarunkowania lokalne, takie jak
                ukształtowanie terenu czy obecność przeszkód. <br /> <br />
                <b>
                  Jeśli masz wątpliwości co do wyboru odpowiedniej anteny lub
                  chcesz uzyskać fachową pomoc,{" "}
                  <Link to="/contact">skontaktuj się z nami</Link>!
                </b>
              </p>
            </Col>
          </Row>
        </div>

        <div ref={boxRef}>
          <Row
            className={`mx-5 p-4 hint1 mb-5 ${
              activeIcon === "lightning" ? "hint-active" : ""
            }`}
          >
            <Col md={7} className="hint1__left">
              <FontAwesomeIcon icon={faBoltLightning} className="icon-tips" />
              <span className="tips2">
                {" "}
                Jak zapobiegać uszkodzeniom instalacji antenowych?{" "}
              </span>
              <p className="tips-p reveal3">
                <br />
                <b>1. Zabezpieczenie instalacji antenowej</b> <br />
                • Zabezpieczenia odgromowe - Przy wyładowaniu bezpośrednim
                głównym zabezpieczeniem instalacji i wszystkich urządzeń
                korzystających z instalacji jest odgromienie masztu i
                znajdujących się na nim anten. <br />
                • Zabezpieczenia przeciwprzepięciowe - Zastosowanie urządzeń
                przeciwprzepięciowych, zmniejsza ryzyko uszkodzenia urządzeń
                elektronicznych przy pobliskim wyładowaniu. <br />
                <br />
                <b>
                  • Nie ma zabezpieczenia dającego nam 100% ochrony przed
                  skutkami wyładowań. <br />
                  • Każde zastosowane zabezpieczenie spełniające normy w klasie
                  zabezpieczeń – zwiększa nam bezpieczeństwo. <br />• Odłączanie
                  urządzeń od zasilania – Podczas burzy warto odłączyć od prądu
                  telewizory, dekodery oraz inne urządzenia podłączone do
                  instalacji antenowej. Zmniejsza to ryzyko uszkodzenia sprzętu
                  w przypadku nagłego przepięcia.
                </b>
              </p>
            </Col>
            <Col md={5} className="hint1__right">
              <img
                src="/img/lightning.jpeg"
                className="img-fluid reveal2"
                alt="Opening-hours"
              />
            </Col>
          </Row>
        </div>

        <div ref={boxRef}>
          <Row
            className={`mx-5 p-4 hint1 mb-5 ${
              activeIcon === "video" ? "hint-active" : ""
            }`}
          >
            <Col md={7} className="hint1__left">
              <FontAwesomeIcon icon={faVideo} className="icon-tips" />
              <span className="tips2"> Jak dobrać rodzaj monitoringu? </span>
              <p className="tips-p">
                <br />
                <b>1. Rodzaje kamer - czym się różnią? </b> <br />•{" "}
                <b>Kamery IP (Internet Protocol)</b> - działają w oparciu o sieć
                internetową i przesyłają obraz cyfrowo w wysokiej jakości.
                Pozwalają na podgląd zdalny w czasie rzeczywistym oraz
                nagrywanie na serwerze lub w chmurze. <br />•{" "}
                <b>Kamery AHD (Analog High Definition)</b> - To klasyczne kamery
                analogowe oferujące obraz w wysokiej rozdzielczości. Działają na
                kablach koncentrycznych i są tańszą alternatywą dla kamer IP.
                <br />•{" "}
                <b>Kamery HDCVI (High Defintion Composite Video Interface)</b> -
                Technologia stworzona przez Dahua, zapewniająca transmisję w
                wysokiej jakości (HD, Full HD, a nawet 4K) przez kabel
                koncentryczny, bez opóźnień.
                <br />•{" "}
                <b>
                  Kamery HDTVI - (High Definition Transport Video Interface)
                </b>{" "}
                - Podobna do HDCVI, ale opracowana przez firmę Hikvision.
                Również umożliwia przesyłanie wysokiej jakości obrazu przez
                kabel koncentryczny.
                <br />
              </p>
            </Col>
            <Col md={5} className="hint1__right">
              <img
                src="/img/camera.jpg"
                className="img-fluid reveal3"
                alt="Opening-hours"
              />
            </Col>
            <Col sm={12}>
              <p className="tips-p">
                <b>2. Rodzaje kamer - jakie wybrać w zależności od potrzeb?</b>
                <br />
                <b>• Kamery stacjonarne </b> - Zamontowane w stałej pozycji,
                monitorują konkretny obszar. Idealne do monitorowania wejść,
                parkingów, magazynów i wnętrz budynków. <br />•{" "}
                <b>Kamery obrotowe (PTZ - Pan, Tilt, Zoom)</b> - Pozwalają na
                zdalne sterowanie ruchem i zoomowanie obrazu. Sprawdzą się na
                dużych terenach, np. halach produkcyjnych, placach budowy i
                posesjach, gdzie konieczne jest monitorowanie różnych punktów.
                <br />• <b>Kamery tubowe i kopułkowe</b> - różnią się kształtem,
                lecz pełnią podobne funkcje. Tubowe lepiej sprawdzają się na
                zewnątrz (odporne na warunki atmosferyczne), a kopułkowe są
                bardziej dyskretne i stosowane wewnątrz budynków.
                <br />
                <br />
                <b>3. Na co jeszcze zwrócić uwagę przy wyborze monitoringu?</b>
                <br />
                <b>• Rozdzielczość obrazu </b> - im wyższa, tym więcej
                szczegółów można zobaczyć. Standardowe wartości to 720p, 1080p,
                4MP, 5MP, czy 4K. <br />• <b>Typ rejestratora</b> - rejestratory
                DVR obsługują systemy analogowe, natomiast NVR są przeznaczone
                dla kamer IP.
                <br />• <b>Pojemność dysków twardych</b> - im większa, tym
                dłużej można przechowywać nagrania. Warto wybrać specjalne dyski
                do monitoringu (np. serii WD Purple, Seagate SkyHawk).
                <b>• Podczerwień (IR) i tryb nocny </b> - kamery z wbudowanym
                emiterem podczerwieni pozwalają na nagrywanie w ciemności. Ważne
                jest, by miały odpowiedni zasięg IR (np. 20 m, 50 m, 100 m).{" "}
                <br /> <b>• Detekcja ruchu </b> - funkcja pozwalająca na
                nagrywanie tylko wtedy, gdy w kadrze wykryto ruch, co oszczędza
                miejsce na dysku. <br />
                <b>• Powiadomienia na telefon </b> - nowoczesne systemy
                umożliwiają wysyłanie alertów o wykrytym ruchu lub nietypowych
                zdarzeniach bezpośrednio na smartfona. <br />
                <br />
                Wybór odpowiedniego systemu monitoringu zależy od specyfiki
                obiektu i indywidualnych potrzeb. Warto zastanowić się nad typem
                kamer, ich funkcjonalnością oraz dodatkowymi parametrami, które
                wpłyną na jakość i skuteczność monitoringu.
                <br />
                <br />
                <b>
                  Jeśli nie wiesz, który system będzie najlepszy dla Ciebie,{" "}
                  <Link to="/contact">skontaktuj się z nami</Link>!
                </b>
              </p>
            </Col>
          </Row>
        </div>

        <div ref={boxRef}>
          <Row
            className={`mx-5 p-4 hint1 mb-5 ${
              activeIcon === "warehouse" ? "hint-active" : ""
            }`}
          >
            <Col md={7} className="hint1__left">
              <FontAwesomeIcon icon={faWarehouse} className="icon-tips" />
              <span className="tips2"> Jak dbać o automatykę bramy? </span>
              <p className="tips-p">
                <br />
                <b>1. Brama przesuwna </b> <br />•{" "}
                <b>Regularne czyszczenie szyny jezdnej </b> - zimą lód i mróz
                mogą ją uszkodzić, a przez resztę roku gromadzi kurz, piasek i
                liście. Każdy element konstrukcyjny musi być najpierw
                wyczyszczony, a następnie zakonserwowany. <br />•{" "}
                <b>Dokładne czyszczenie elementów</b> - warto usuwać stare
                smary, kurz i brud za pomocą sprężonego powietrza i myjki
                ciśnieniowej.
                <br />• <b>Odpowiednie smarowanie</b> - używaj wysokogatunkowego
                suchego smaru w aerozolu, który nie przyciąga zabrudzeń.
                <br />• <b>Konserwacja prowadnic i rolek</b> - zwróć uwagę na
                celowniki bramowe, wózek oraz rolki najazdowe i prowadzące.
                <br />• Jeśli brama nie jest zdemontowana, możesz ją powoli
                przesuwać i jednocześnie pryskać suchy smar.
                <br />
              </p>
            </Col>
            <Col md={5} className="hint1__right">
              <img
                src="/img/gate.jpg"
                className="img-fluid reveal2"
                alt="Opening-hours"
              />
            </Col>
            <Col sm={12}>
              <p className="tips-p">
                <b>2. Brama skrzydłowa z napędem (uchylna)</b>
                <br />
                <b>• Kontrola siłowników </b> - sprawdzaj je co najmniej dwa
                razy w roku, przed i po zimie.
                <br />• <b>Sprawdzenie elektroniki</b> - okablowanie i
                sterowanie również warto skontrolować dwa razy w roku.
                <br />• <b>Stan uszczelek i lakieru</b> - jeśli widzisz oznaki
                zużycia lub korozji, zabezpiecz je odpowiednimi środkami.
                <br />• <b>Czyszczenie siłownika</b> - unikaj zalegania piasku i
                błota, które mogą uszkodzić uszczelniacze i tłok.
                <br />• <b>Smarowanie</b> - stosuj silikonowy smar w sprayu, aby
                chronić uszczelniacze i zapobiec przedostawaniu się wody.
                <br />
                <br />
                <b>3. Fotokomórki i zabezpieczenia </b>
                <br />
                <b>• Regularne odśnieżanie </b> - usuwaj śnieg i inne przeszkody
                blokujące działanie czujników.
                <br />• <b>Test działania</b> - sprawdzaj reakcję systemu,
                przerywając promień w trakcie ruchu bramy. Pamiętaj o zachowaniu
                odpowiedniej odległości.
                <br />• <b>Czyszczenie „okienek” fotokomórek</b> - zabrudzenia
                mogą osłabić sygnał i zakłócić działanie systemu bezpieczeństwa.
                <br />
                <br />
                <b>
                  Regularna konserwacja przedłuża żywotność bramy i zapewnia jej
                  niezawodne działanie!
                </b>
              </p>
            </Col>
          </Row>
        </div>
        <hr className="custom-hr" />
      </Container>
    </>
  );
};

export default Hero;
